// 앱의 전역 설정 파일

// true: 무료 앱 출시 모드 (광고, 프리미엄 결제 UI 임시 숨김 처리 및 그룹 무제한 생성 허용)
// false: 수익화 모델 적용 모드 (구글 애드센스, 광고 대기, 프리미엄 결제 활성화)
export const IS_FREE_LAUNCH_PHASE = true;
